import React from 'react';
import { Link } from 'react-router-dom';
import MenuDamList from './MenuDamList';
import MenuSeismic from './MenuSeismic';
import MenuPressureGraph from './MenuPressureGraph';
import { MenuContainer, MenuList, MenuListItem } from './styles';

export default (props) => {
  const {
    damList,
    seismic: { enable: seismicEnable, station },
    pressure: {
      enable: pressureEnable,
      waterStorage: { enable: storageEnable },
    },
    seepage: { enable: seepageEnable },
    seepage_v2: { enable: seepageV2Enable },
    rain: { enable: rainEnable },
  } = props;

  return (
    <MenuContainer className="row hidden-sm hidden-xs">
      <div className="col-xs-12">
        <MenuList className="nav nav-pills pull-right">
          <MenuDamList damList={damList} />
          {pressureEnable && (
            <MenuListItem>
              <Link to="/">ระบบจำลองเหตุการณ์</Link>
            </MenuListItem>
          )}
          {pressureEnable && (
            <MenuPressureGraph
              rainEnable={rainEnable}
              storageEnable={storageEnable}
              seepageEnable={seepageEnable}
              seepageV2Enable={seepageV2Enable}
            />
          )}
          {seismicEnable && <MenuSeismic station={station} />}
        </MenuList>
      </div>
    </MenuContainer>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuLink/index.js